"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1561))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.695Z
 */
export const EstimatedDeliveryDate = createSVGIcon(
  <>
    <path
      d="M20.4002 22.8001C21.0367 22.8001 21.6472 22.5472 22.0973 22.0972C22.5473 21.6471 22.8002 21.0366 22.8002 20.4001V6.0001C22.8002 5.36358 22.5473 4.75313 22.0973 4.30304C21.6472 3.85295 21.0367 3.6001 20.4002 3.6001H3.6002C2.96368 3.6001 2.35323 3.85295 1.90314 4.30304C1.45305 4.75313 1.2002 5.36358 1.2002 6.0001V20.4001C1.2002 21.0366 1.45305 21.6471 1.90314 22.0972C2.35323 22.5472 2.96368 22.8001 3.6002 22.8001"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 1.2002V3.6002"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 1.2002V3.6002"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.2002 9.6001H22.8002"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.80029 19.8003L10.8003 22.8003L16.8003 16.8003"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "EstimatedDeliveryDate",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
